import { Fragment } from "react";
import styled from "styled-components";
import { Typography, Checkbox, Grid } from "@mui/material";
import { ToggleOnOutlined, ToggleOffOutlined } from "@mui/icons-material";

import Input from "./audience fields/Input";
import Range from "./audience fields/Range";
import DropDown from "./audience fields/Dropdown";
import DatePicker from "./audience fields/DatePicker";
import AudienceName from "./audience fields/AudienceName";
import { colors } from "../../css components/Style";
import { Paper } from "../../../components";

const Heading = styled(Typography)`
  font-size: 15px;
  font-weight: 500;
  line-height: 27px;
  align-self: center;
`;

export default function FormOne({
  setFields,
  state,
  dispatch,
  fields,
  editState,
  formikProps,
  setButtonDisable,
  includedSegments,
  messages,
  disaptchMessage,
}) {
  return (
    <Fragment>
      <Paper>
        <Grid size={12} style={{ margin: "20px 0" }}>
          <Typography variant="h4" color={colors.publicisBlue}>
            Audience Details
          </Typography>
        </Grid>

        <AudienceName
          setFields={setFields}
          state={state}
          dispatch={dispatch}
          editState={editState}
          formikProps={formikProps}
          messages={messages}
          disaptchMessage={disaptchMessage}
        />
      </Paper>

      {includedSegments?.map((segment) => (
        <Paper>
          <Grid size={12} style={{ margin: "20px 0" }}>
            <Typography variant="h4" color={colors.publicisBlue}>
              {segment.segmentTitle}
            </Typography>
          </Grid>

          {fields[segment?.segmentID] ? (
            fields[segment?.segmentID].map((field) => (
              <Fragment>
                {field.control_id === 3 && (
                  <Input
                    messages={messages}
                    disaptchMessage={disaptchMessage}
                    setButtonDisable={setButtonDisable}
                    state={state}
                    dispatch={dispatch}
                    editState={editState}
                    field={field}
                    formikProps={formikProps}
                  />
                )}

                {field.control_id === 1 && (
                  <Range
                    messages={messages}
                    disaptchMessage={disaptchMessage}
                    setButtonDisable={setButtonDisable}
                    state={state}
                    dispatch={dispatch}
                    editState={editState}
                    field={field}
                    formikProps={formikProps}
                  />
                )}

                <DropDown
                  messages={messages}
                  disaptchMessage={disaptchMessage}
                  state={state}
                  dispatch={dispatch}
                  editState={editState}
                  field={field}
                  formikProps={formikProps}
                />

                {field.control_id === 4 && (
                  <DatePicker
                    messages={messages}
                    disaptchMessage={disaptchMessage}
                    state={state}
                    dispatch={dispatch}
                    editState={editState}
                    field={field}
                    formikProps={formikProps}
                  />
                )}
              </Fragment>
            ))
          ) : (
            <Grid size={12} textAlign={"center"}>
              <Typography variant="h6" color={colors.publicisBlue}>
                Fields coming soon for this category.
              </Typography>
            </Grid>
          )}
        </Paper>
      ))}
    </Fragment>
  );
}

export function Mandatory({ state, field, dispatch, editState }) {
  function handleCheckChange(value, name, key) {
    dispatch({
      type: "CALCULATE_PERCENTAGE",
      payload: { value, name, key },
    });
  }

  return (
    <div style={{ display: "flex", justifyContent: "end" }}>
      <Heading
        style={{
          color: state?.[field.name]?.mandatory ? "red" : "gray",
        }}
      >
        Mandatory
      </Heading>

      <Checkbox
        style={{ padding: "3px 9px" }}
        disabled={
          field.control_id === 1
            ? !state?.[field.name]?.value?.min ||
              !state?.[field.name]?.value?.max ||
              !editState
            : !editState ||
              !state?.[field.name]?.value ||
              state?.[field.name]?.value?.length === 0
        }
        name={`${field.name}.mandatory`}
        onChange={(e) => {
          handleCheckChange(e.target.checked, field.name, "mandatory");
        }}
        checked={state?.[field.name]?.mandatory}
        icon={<ToggleOffOutlined fontSize="large" />}
        checkedIcon={
          <ToggleOnOutlined
            fontSize="large"
            style={{
              color: state?.[field.name]?.mandatory ? "red" : "#cbcbcb",
            }}
          />
        }
      />
    </div>
  );
}
